import repository from './repsitory'

const resource = '/address'

export default {

    getProvinces () {
        return repository.get(`${resource}/provinces`)
    },
    getCounties (provinceId) {
        return repository.get(`${resource}/counties/${provinceId}`)
    },
    getDistricts (countyId) {
        return repository.get(`${resource}/districts/${countyId}`)
    },
}
